
import ReactEcharts from "echarts-for-react";
import { useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Agent from "../../../Network/Agent";
export default function PowerAvailability() {

    const echarts_react_1 = useRef();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState("daily");
    const [labels, setLabels] = useState([]);
    const [acData, setAcData] = useState([]);
    const [dcData, setDcData] = useState([]);
    const [site_id, setSiteId] = useState();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState('Last 30 Days');
    const chartInstance = echarts_react_1.current?.getEchartsInstance();
    const array_data = {
        'site_id': '',
        'from_date': startDate,
        'to_date': endDate,
        'filter_type': filter
    };

    function onchangeSite(value) {
        array_data.site_id = value;
        setSiteId(value);
        fetchData();
    }

    const fetchData = async () => {
        chartInstance?.showLoading('default', {
            text: 'Loading...',
            color: '#cbfa5cff',
            textColor: '#000',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            zlevel: 0
        });
        Agent.MANAGEMENT_DASHBOARD.power_availability(array_data).then((res) => {
            setLabels(res.data.data.labels);
            setAcData(res.data.data.ac_data);
            setDcData(res.data.data.dc_data);
            chartInstance?.hideLoading();
        }).catch((error) => {
            console.error("Error fetching power availability data:", error);
        });
    };


    // Fetch data when the component mounts or when the filter changes

    useEffect(() => {
        if (site_id) {
            array_data.site_id = site_id;
        } else {
            array_data.site_id = '';
        }

        array_data.filter_type = filter;
        if (filter === "custom") {
            setShowModal(true);
            return;
        }
        else {
            setShowModal(false);
        }

        fetchData();

    }, [filter]);


    const labelOption = {
        show: true,
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'top',
        formatter: '{c} %',

        fontSize: 12,
        rich: {
            name: {}
        }
    };
    const option = {
        title: {
            text: '',
            subtext: ''
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['AC', 'DC']
        },
        toolbox: {
            show: true,
            feature: {

                saveAsImage: { show: true }
            }
        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                data: labels,
                axisLabel: {
                    interval: 0,
                    rotate: 45,
                    fontSize: 12
                },
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#ddd'
                    }
                }

            }
        ],
        yAxis: [
            {
                name: 'Percentage',
                nameLocation: 'middle',
                nameGap: 60,
                nameTextStyle: {
                    fontWeight: 'bold',
                    color: '#000000'
                },
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisLabel: {
                    formatter: '{value}'
                },
                axisPointer: {
                    snap: true
                }

            }
        ],
        series: [
            {
                name: 'AC',
                type: 'bar',
                data: acData,
                label: labelOption
            },
            {
                name: 'DC',
                type: 'bar',
                data: dcData,
                label: labelOption
            }
        ]
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Get the start and end dates from the form
        const startDateInput = e.target.startDate.value;
        const endDateInput = e.target.endDate.value;
        // Validate date range
        if (!startDateInput || !endDateInput) {
            alert("Please select both start and end dates.");
            return;
        }
        if (startDateInput > endDateInput) {
            alert("Start date cannot be later than end date.");
            return;
        }
        // Update array_data with selected dates
        if (startDateInput && endDateInput) {
            array_data.from_date = startDateInput;
            array_data.to_date = endDateInput;
            array_data.filter_type = 'custom';
            setStartDate(new Date(startDateInput));
            setEndDate(new Date(endDateInput));
            setShowModal(false);
            fetchData();
        }
    }

    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5>Power Availability</h5>
                    <div className="d-flex gap-2">
                        <input type="text" className="form-control form-control-sm" placeholder="search by site id.." onKeyUp={(e) => onchangeSite(e.target.value)} />
                        <div className="dropdown">
                            <button
                                className="btn dropdown-toggle"
                                type="button"
                                id="filterDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {selected}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="filterDropdown">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            setFilter("daily");
                                            setSelected("Last 30 Days");
                                        }}
                                    >
                                        Last 30 Days
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            setFilter("monthly");
                                            setSelected("Monthly");
                                        }}
                                    >
                                        Monthly
                                    </button>
                                </li>

                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            setFilter("custom");
                                            setSelected("Date Range");
                                            setShowModal(true);
                                        }}
                                    >
                                        Date Range
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div class="dropdown">
                            <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown">
                                Export
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#">CSV</a></li>
                                <li><a class="dropdown-item" href="#">XLSX</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body p-0 m-0">
                    <ReactEcharts ref={echarts_react_1} style={{ height: "300px" }} option={option} />

                </div>
            </div>

            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Custom Date Range</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSubmit} id="add_country_form">

                                <div className="modal-body">
                                    <div className="mb-2">
                                        <label className="form-label">From Date</label>
                                        <input
                                            type="date"
                                            name="startDate"
                                            className="form-control"

                                            onChange={(e) => setStartDate(new Date(e.target.value))}
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label">To Date</label>
                                        <input
                                            type="date"
                                            name="endDate"
                                            className="form-control"
                                            onChange={(e) => setEndDate(new Date(e.target.value))}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
                                    <button
                                        className="btn btn-info btn-sm"
                                        disabled={!startDate || !endDate}
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}